<template>
    <div class="card-list">
        <div
            v-for="item in items"
            :key="item.value"
            class="card-list__item"
            :class="{ 'card-list__item--selected': isSelected(item), 'card-list__item--disabled': item.disabled }"
            @click="select(item)"
        >
            <Radio :model-value="isSelected(item)" :disabled="item.disabled" />
            <span class="card-list__label"><slot :item="item">{{ item.label }}</slot></span>
        </div>
    </div>
</template>
<script>
import Radio from "../form/radio/Radio.vue";

export default {
    name: "RadioCardList",
    components: { Radio },
    emits: ['update:modelValue'],
    props: {
        items: {
            type: Array,
            default: () => []
        },
        modelValue: {
            type: Object,
            default: null
        }
    },
    methods: {
        isSelected(item) {
            return this.modelValue?.value === item.value;
        },
        select(item) {
            if (item.disabled) {
                return;
            }

            this.$emit('update:modelValue', item);
        }
    }
}
</script>
<style scoped>
.card-list {
    display: flex;
    flex-direction: column;
    gap: 0.625rem;
}

.card-list__item {
    display: flex;
    align-items: center;
    gap: 0.625rem;
    width: 100%;
    padding: 0.625rem 0.875rem;
    border: 1px solid #dee2e6;
    border-radius: 0.1875rem;
    cursor: pointer;
    background-color: #fff;
    user-select: none;
    transition: border-color 0.15s ease, background-color 0.15s ease;
}

.card-list__item--selected {
    border-color: #2196F3;
    background-color: rgba(33, 150, 243, 0.06);
}

.card-list__item--disabled {
    cursor: not-allowed;
    opacity: 0.6;
}

.card-list__label {
    flex: 1;
}
</style>
